import { render } from "./AudienceBulkAddForm.vue?vue&type=template&id=30ad4353"
import script from "./AudienceBulkAddForm.vue?vue&type=script&lang=js"
export * from "./AudienceBulkAddForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__